import { useNavigate } from 'react-router-dom';
import { ProfileContext } from '../contexts';
import { useContext, useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';

export function useProtectComponent(RouteComponent) {
  const navigate = useNavigate();
  const { profile } = useContext(ProfileContext);
  const [loading, setLoading] = useState(true);

  const isDeadlineOver = profile?.deadline?.isDeadlineOver;
  useEffect(() => {
    setLoading(false);
    if (typeof isDeadlineOver !== 'boolean') {
      return;
    }
    if (!profile?.email) {
      const path = `/checkLogin?returnTo=${window.location.pathname}`;
      window.location.replace(path);
      return;
    }
    if (isDeadlineOver && !profile?.isAdmin) {
      navigate('/');
      return;
    }
  }, [profile]);

  if (loading) {
    return <CircularProgress />;
  }

  return <RouteComponent />;
}
